import React from 'react';
import { getExtension } from '../../fileUploadUtils';
import { getFileName } from '../../../../../pages/Dashboard/dashboard-components/DashboardNotifications/notificationUtils';
import { DescriptionOutlined } from '@mui/icons-material';

const extensionToImg: Record<string, string> = {
  '.xls': '/assets/icons/files/excel.png',
  '.xlsx': '/assets/icons/files/excel.png',
  '.doc': '/assets/icons/files/word.png',
  '.docx': '/assets/icons/files/word.png',
  '.pdf': '/assets/icons/files/pdf.svg',
};

interface Props {
  fileUrl: string;
  onDelete: (_args?: any) => void;
  onClick: () => void;
  disabled: boolean;
  hasComments: boolean;
}
export const FileTitle: React.FC<Props> = ({ fileUrl, onDelete, onClick, disabled, hasComments }) => (
  <div className="flex gap-1 text-sm text-nowrap w-72 ">
    <div onClick={onClick} className="flex gap-1 items-center flex-1">
      <FileIcon extension={getExtension(fileUrl)} />
      <p className="max-w-52 overflow-hidden text-ellipsis">{getFileName('fileName', fileUrl, true)}</p>
    </div>

    <div className="flex justify-end gap-1">
      {hasComments && <img src="/assets/icons/blue-flat/comment.svg" alt="com" className="h-6 w-6" onClick={onClick} />}
      {!disabled && <img src="/assets/icons/blue-flat/delete.svg" alt="del" className="h-6 w-6" onClick={onDelete} />}
    </div>
  </div>
);

const FileIcon: React.FC<{ extension: string }> = ({ extension }) => {
  return extensionToImg[extension] ? (
    <img src={extensionToImg[extension]} alt="file" className="w-6 h-6" />
  ) : (
    <DescriptionOutlined />
  );
};
